import ShrMapFactory from "./map-factory";

// Map to show locations from all regions
const ShrGlobalMapInit = () => {
  const mapWrapperEls = document.querySelectorAll(".js-global-map-wrapper");
  const mapWrappers = [...mapWrapperEls];

  if (mapWrappers.length > 0) {
    mapWrappers.forEach(async (el) => {
      const config = JSON.parse(el.dataset.mapConfig);
      const markers = JSON.parse(el.dataset.markers);

      const map = new ShrMapFactory(el, config, markers);
      await map.init();
    });
  }
};

export default ShrGlobalMapInit;
